<template>
  <loader v-if="dataLoading"></loader>
  <div class="notification-support" v-else>
    <div class="notification-support__header">
      <div class="header__title">
        <span>Доступність сервісів</span>
      </div>
    </div>
    <div class="notification-support__body">
      <div class="container">
        <div class="table-header">
          <div class="empty-block">
            <div class="empty"></div>
          </div>
          <div class="time-block" :class="{ afternoon: hasTimeGap }">
            <div class="cell" v-for="timeSlot in timeSlots" :key="timeSlot.id">
              <span class="hours">{{ formattedHours(timeSlot.label) }}</span
              ><span class="minutes">{{
                formattedMinutes(timeSlot.label)
              }}</span>
            </div>
          </div>
        </div>
        <div
          v-for="(service, index) in groupedData"
          :key="index"
          class="table-row"
        >
          <div class="services-name">
            <div class="name">{{ getServiceName(service.service) }}</div>
          </div>
          <div class="services-value">
            <div
              v-for="timeSlot in timeSlots"
              :key="timeSlot.id"
              class="cell"
              :class="{
                error:
                  getConversion(
                    service.time_points,
                    timeSlot.start,
                    timeSlot.end
                  ) < 65,
              }"
            >
              <svg
                v-if="
                  getConversion(
                    service.time_points,
                    timeSlot.start,
                    timeSlot.end
                  ) >= 65
                "
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#219653" />
                <path
                  d="M2 3L3.5 5L6 2.5"
                  stroke="white"
                  stroke-width="0.5"
                  stroke-linecap="round"
                />
              </svg>

              <svg
                v-else
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#DD6262" />
                <circle cx="3.99992" cy="5.99967" r="0.666667" fill="white" />
                <path
                  d="M4.66659 2C4.66659 1.63181 4.36811 1.33333 3.99992 1.33333C3.63173 1.33333 3.33325 1.63181 3.33325 2C3.33325 2.36819 3.63173 5 3.99992 5C4.36811 5 4.66659 2.36819 4.66659 2Z"
                  fill="white"
                />
              </svg>
              <div class="conversion">
                <span
                  >{{
                    getConversion(
                      service.time_points,
                      timeSlot.start,
                      timeSlot.end
                    )
                  }}%</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import Loader from '@vue-app/components/base/Loader.vue'

export default {
  name: 'NotificationSupport',
  props: {
    dataLoading: {
      type: Boolean,
      default: false,
    },
    groupedData: {
      type: Array,
      default: () => [],
    },

    services: {
      type: [Object, Array],
      default: () => ({
        '3DS UPC': '-"xpaytoupc/api/3ds2_2/cavv/"',
        '3DS PUMB': '-"v1/cavv"',
        'АБС Б2': '-"api/v2/contragent/id"',
        'VISA C2A': '-"pullFundsTransactionsPost"',
        'VISA A2C': '-"pushFundsTransactionsPost"',
        'MASTERCARD C2A': '-"c2a"',
        'MASTERCARD A2C': '-"a2c"',
      }),
    },
  },
  components: {
    Loader,
  },
  data() {
    return {
      isDataLoading: false,
      timeSlots: [],
    }
  },
  mounted() {
    this.generateIntervalSlots()
  },

  computed: {
    hasTimeGap() {
      if (this.timeSlots.length > 0) {
        const startTimeLabel = this.timeSlots[0].label

        if (startTimeLabel === '10:00') {
          return this.timeSlots.some((slot) => {
            const hour = parseInt(slot.label.split(':')[0], 10)
            return hour >= 10 && hour <= 24
          })
        }
      }
      return false
    },
  },

  methods: {
    formattedHours(time) {
      return time === 'Зараз' ? time : time.split(':')[0]
    },

    formattedMinutes(time) {
      return time === 'Зараз' ? '' : `:${time.split(':')[1]}`
    },

    generateIntervalSlots() {
      this.timeSlots = []

      let currentHour = moment().startOf('hour')
      let currentTime = moment()

      for (let i = 3; i >= 0; i--) {
        let startTime = moment(currentHour).subtract(i, 'hours')
        let endTime = moment(startTime).add(1, 'hour')
        let label = startTime.format('HH:mm')

        if (i === 0) {
          this.timeSlots.push({
            id: i + 2,
            label,
            start: startTime,
            end: endTime,
          })

          startTime = moment(currentTime).startOf('hour')
          endTime = moment(startTime).add(1, 'hour')
          this.timeSlots.push({
            id: i + 1,
            label: `Зараз`,
            start: startTime,
            end: endTime,
          })
        } else {
          this.timeSlots.push({
            id: i + 3,
            label,
            start: startTime,
            end: endTime,
          })
        }
      }
    },

    findServiceTimePoint(service, startTime, endTime) {
      if (!service || !service.time_points) {
        return null
      }

      return service.time_points.find((point) => {
        let dtFrom = moment(point.dt_from).format('HH')
        let dtTo = moment(point.dt_to).format('HH')

        return dtFrom >= startTime.format('HH') && dtTo <= endTime.format('HH')
      })
    },

    getConversion(service, startTime, endTime) {
      let timePoint = this.findServiceTimePoint(
        { time_points: service },
        startTime,
        endTime
      )

      if (timePoint && timePoint.conversion !== undefined) {
        return timePoint.conversion
      } else {
        return 0
      }
    },

    getServiceName(serviceKey) {
      switch (serviceKey) {
        case '-"xpaytoupc/api/3ds2_2/cavv/"':
          return '3DS UPC'
        case '-"v1/cavv"':
          return '3DS PUMB'
        case '-"api/v2/contragent/id"':
          return 'АБС Б2'
        case '-"pullFundsTransactionsPost"':
          return 'VISA C2A'
        case '-"pushFundsTransactionsPost"':
          return 'VISA A2C'
        case '-"c2a"':
          return 'MASTERCARD C2A'
        case '-"a2c"':
          return 'MASTERCARD A2C'
        default:
          return serviceKey
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.notification-support {
  padding: 30px 50px 20px 20px;
  background-color: #fff;
  border-radius: 20px;
  width: 530px;
  &__header {
    .header__title {
      padding-bottom: 20px;
      span {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        color: #585f6d;
        text-transform: uppercase;
      }
    }
  }

  &__body {
    .container {
      display: flex;
      flex-direction: column;
      border-collapse: collapse;
      width: 100%;
      margin-top: 30px;
    }

    .table-header {
      position: relative;
      display: flex;
      width: 100%;
      padding-bottom: 5px;
      .empty-block {
        width: 165px;
      }
      .empty {
        background-color: #fff;
        width: 180px;
      }
      .cell {
        font-size: 14px;
        color: #666d79;
        font-weight: 600;
        width: 100%;

        &:first-child {
          border-top-left-radius: 20px;
        }

        &:last-child {
          border-top-right-radius: 20px;
        }
      }

      .time-block {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;

        .cell {
          display: flex;
          margin-right: 30px;
          .minutes {
            font-weight: 500;
            font-size: 10px;
          }

          &:last-child {
            margin-right: 0;
          }
        }

        &.afternoon {
          gap: 10px;
        }
      }
    }

    .table-row {
      display: flex;
      border-top: 1px solid #f7f9fc;
      border-left: 1px solid #f7f9fc;
      border-right: 1px solid #f7f9fc;
      border-bottom: none;
      width: 100%;
      .services-name {
        display: flex;
        align-items: center;
        width: 180px;
        padding-left: 20px;
        border-right: 1px solid #f7f9fc;
        .name {
          width: 100%;
          font-size: 14px;
          font-weight: 600;
          color: #666d79;
          background-color: #fff;
        }
      }

      .services-value {
        display: flex;
        flex: 1;

        .cell {
          position: relative;
          cursor: pointer;
          width: 100%;
          padding: 10px;
          text-align: center;
          font-size: 14px;
          color: #666d79;
          font-weight: 600;
          border-right: 1px solid #f7f9fc;
          background-color: #fff;

          .conversion {
            visibility: hidden;
            width: 75px;
            background-color: #fff;
            border: 1px solid #f4f3fc;
            color: #47475e;
            text-align: center;
            border-radius: 6px;
            padding: 5px 0;
            position: absolute;
            z-index: 1;
            bottom: 125%;
            left: 50%;
            margin-left: -60px;
            opacity: 0;
            transition: opacity 0.3s;

            &::after {
              content: '';
              position: absolute;
              top: 100%;
              left: 50%;
              margin-left: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: #fff transparent transparent transparent;
            }
          }

          &:hover {
            .conversion {
              visibility: visible;
              opacity: 1;
            }
          }

          &:last-child {
            border-right: none;
            display: none;
          }
        }

        .error {
          background-color: #ffefef;
        }
      }

      &:last-of-type {
        border-bottom: 1px solid #f7f9fc;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
      }

      &:nth-of-type(2) {
        border-top-left-radius: 20px;
      }
    }

    svg {
      fill: none;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
}
</style>
